export default class GameCommunicatorDefault {
  vm = undefined;
  constructor(vm) { this.vm = vm }

  postMessage (data) {
    switch (data) {
      case 'autoplayOff':
        this.vm.autoplayStopped();
        break;
      case 'stopGame':
        this.vm.gameStopped();
        break;
      case 'resumeGame':
        this.vm.gameStarted();
        break;
    }
    console.log('GameCommunicator sent the following message: ', data);
  }
}
